import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, delay, forkJoin, Observable, of, switchMap, tap } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class TranslationService {
  public translatedArray: any = [];
  public languageType: string = '';
  public translationContent = new BehaviorSubject<any>(this.translatedArray);
  public sharetranslationData = this.translationContent.asObservable();
  public languageContent = new BehaviorSubject<any>(this.languageType);
  public sharelanguageType = this.languageContent.asObservable();
  private _featureFlags: any = null;
  private readonly _featureFlagLink = environment.featureFlagLink
  private _supportedLanguagesForDisplay: any[] = [];
  public supportedLanguages: any[] = [];
  public _cpSecrets: any;

  constructor(private readonly httpClient: HttpClient) {
   }
  sendtranslationValue(value: any) {
    this.translationContent.next(value);
  }
  sendSelectedLanguage(value: any) {
    this.languageContent.next(value);
  }


  setLanguageType(type: any) {
    this.languageType = type;
  }
  getLanguageType() {
    return this.languageType;
  }

  getCpSecretsFromKeyVault() {
    return this.httpClient.get<any>(`${environment.proxyEndpoint}/accessKeys/accessCustomerPortalKeys`);
  }

  public set cpSecrets(secrets: any) {
    this._cpSecrets = secrets;
  }

  public get cpSecrets() {
    return this._cpSecrets;
  }

  public getCustomerPortalConfiguration(languageId?: string) {
    if (!this._cpSecrets) {
      this.getCpSecretsFromKeyVault().subscribe(
        (secrets: any) => {
          this._cpSecrets = secrets;
      })
    } 
  }

  public set featureFlags(flags: any) {
    this._featureFlags = flags;
  }

  public get featureFlags() {
    return this._featureFlags;
  }

  public getAllFeatureFlags(): Observable<any> {
    let featureFlags = this.httpClient.get(this._featureFlagLink)
    return featureFlags
  }

     /**
   * @description To be replaced by actual API. Gives list of all supported languages
   * @returns list of languages
   * !IMPORTANT: While testing with actual API, ensure error scenarios are also handled
   */
     public getAllSupportedLanguages(): Observable<any> {
      const res = require('../../app/components/language-selection-page/language-list.json');
      return of(res).pipe(delay(100));
    }

    public set supportedLanguagesForDisplay(languages: any[]) {
      const defaultLangs = ['en', 'de'];
      const langCodes = this.getLanguageCodes(languages)
      langCodes.push(...defaultLangs);
      this.setSupportedLanguageByCode(langCodes);
      this._supportedLanguagesForDisplay = languages.filter((lan: any) => lan.show);
    }

    public getLanguageCodes(languages: any[]): string[] {
      const langCodes = languages
      .filter(lang => lang.show)
      .map(lang => lang.localeCode)
      return langCodes;
    }

    public get supportedLanguagesForDisplay(): any[] {
      return this._supportedLanguagesForDisplay;
    }

    public setSupportedLanguageByCode(languages: string[]) {
      this.supportedLanguages = languages;
    }

  /**
    * @description We are using this method to pass a valid language to translations API
    * If user has added any invalid language, pass the default language
    * @param locale
    * @returns
    */
   public isLangIdValid(locale:any): string {
    const languages = require('../../app/components/language-selection-page/language-list.json');
    const langCodes = this.getLanguageCodes(languages);
      if(langCodes.includes(locale)){
       return locale
      }else{
       return 'en-GB'
      }
   }


}

